module.exports = __webpack_public_path__ + "img/tattoo02.09ce9af2.jpg";